module.exports = __webpack_public_path__ + "media/images/Kitchen Cabinets with Plants-3b25bfe1.webp";